export const questions = [
    {
      question: "How many trips did we go on together in Year 3?",
      options: [
        "2",
        "3 ",
        "4", // Correct Answer - EDC, Socal BP, Bodega Bay, SF
        "5"
      ],
      correctIndex: 2
    },
    {
      question: "Did I make any modifications to my car in Year 3?",
      options: [
        "Yes", 
        "No" // Correct Answer
      ],
      correctIndex: 1
    },
    {
      question: "What color jacket did I wear to the winery during our Bodega Bay Trip?",
      options: [
        "Blue",
        "Black", // Correct Answer
        "White",
        "Green"
      ],
      correctIndex: 1
    },
    {
      question: "Do you guys carry dust absorbant plants?",
      options: [
        "Yes",
        "Yes",
        "Yes",
        "No" // Correct Answer
      ],
      correctIndex: 3
    },
    {
      question: "About how many pokemon card packs did we open together?",
      options: [
        "<28",
        "29-45",
        "46-65", // Correct Answer
        "66+"
      ],
      correctIndex: 2
    },
    {
      question: "What number was Kobe Bryant in the NBA?",
      options: [
        "22",
        "24", // Correct Answer
        "26",
        "28"
      ],
      correctIndex: 1
    },
    {
      question: "Which activity did we NOT do in Year 3?",
      options: [
        "Axe Throwing",
        "Attend a Jousting Match",
        "Pickleball", // Correct Answer
        "Hiking"
      ],
      correctIndex: 2
    },
    {
      question: "About how many trips did we go on combined in Year 3?",
      options: [
        "2-5",
        "6-9",
        "10-13", // Correct Answer - Cameron: EDC, Europe, Asia, Bodega Bay, Socal, Austin. Aly: EDC, Vietnam, Bodega Bay, Socal x3
        "14+"
      ],
      correctIndex: 2
    },
    {
      question: "Who is the better photographer?",
      options: [
        "Cam", // Correct Answer
        "Aly",
      ],
      correctIndex: 0
    },
    {
      question: "Who is the cutest of all time (COAT)?",
      options: [
        "Cam",
        "Aly", // Correct Answer
      ],
      correctIndex: 1
    },
    {
      question: "During Santacon which beer did Aly say she liked?",
      options: [
        "IPA",
        "Golden State Cider",
        "Pale Ale",
        "805" // Correct Answer
      ],
      correctIndex: 3
    },
    {
      question: "Roughly how many times did we go to Mendocino Farms in Year 3?",
      options: [
        "Once",
        "2-3",
        "4-5", // Correct Answer
        "6+"
      ],
      correctIndex: 2
    },
    {
      question: "How many KMs did we run together in Year 3?",
      options: [
        "20km", // Correct Answer
        "25km",
        "30km",
        "35km"
      ],
      correctIndex: 0
    },
    {
      question: "How many goals did Son Heung-min score in the game vs. Earthquakes @ Levi's Stadium?",
      options: [
        "1", // Correct Answer
        "2",
        "3",
        "4+"
      ],
      correctIndex: 0
    },
    {
      question: "What did Cameron make in the tufting class?",
      options: [
        "Spongebob Squarepants",
        "Tony Tony Chopper", // Correct Answer
        "Patrick Star",
        "Monkey D. Luffy"
      ],
      correctIndex: 1
    }
];